var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleCurl2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 504,
    viewBox: "0 0 247 504",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1238_2415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 247,
    height: 504
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 504,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1238_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.254 273.444C553.798 566.765 26.4798 516.266 204.432 337.865C221.232 323.088 261.683 289.428 322.194 295.185C397.832 302.381 368.631 342.954 314.365 355.885C285.922 362.663 100.307 374.542 61.3308 282.693C22.3548 190.843 129.435 161.927 250.06 188.65L251.97 196.606C228.144 209.015 72.831 119.462 26.9558 -10.1842",
    stroke: "white",
    strokeWidth: 32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCurl2);
export default __webpack_public_path__ + "static/media/title_curl_2.98894ab7cd23a1e71d6a61d014190f40.svg";
export { ForwardRef as ReactComponent };